import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector, shallowEqual } from 'react-redux';

import { selectElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';

import { useCurrentProduct } from 'components/direct-sales/quote/hooks/useCurrentProduct';
import { usePartner } from 'components/app/routes/usePartner';
import { useIsLoginEnabledJourney } from './useIsLoginEnabledJourney';
import { PARTNERS } from 'config/app-config';

export const useIsEVQuote = () => {
  const isLoginEnabledJourney = useIsLoginEnabledJourney({
    exclude: [PARTNERS.NONDOMESTIC_TRANSFER]
  });
  const {
    releaseEvQuote,
    releaseEvQuoteVoiceSales,
    releaseQuotingEvForHomeMoveJourney
  } = useFlags();
  const { isDSJourney, activePartner } = usePartner();
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];
  const { isEV } = useCurrentProduct();
  const electricVehicle = useSelector(selectElectricVehicle, shallowEqual);
  const isAllowedJourney =
    (!!releaseEvQuote && isDSJourney) ||
    (!!releaseEvQuoteVoiceSales && isLoginEnabledJourney) ||
    (!!releaseQuotingEvForHomeMoveJourney && isMoveInJourney);

  const isEVBeforeQuote = !!electricVehicle && !!isAllowedJourney;

  return {
    isEVQuote: isEV && isEVBeforeQuote,
    isEVBeforeQuote
  };
};
